import React, { useEffect, useState } from "react";
import { Button, Col, Input, Row, Spin, Tabs } from "antd";
import {
  FONT,
  isAdmin,
  ROLE_ADMIN,
  ROLE_ADMIN_CUSTOMER,
  ROLE_USER,
  ROLE_USER_ADMIN,
} from "constants/index";

import { getUsers } from "services/user/user-service";
import UsersClient from "./users-client";
import { ArrowRight, Search } from "lucide-react";
import { notificationErroInternal } from "util/api-utils";
import useBreakpoint from "hooks/useBreakpoint";

const tabLabel = (short, full, className, isMobile) => (
  <span className={`users-tab-label ${className}`}>
    {isMobile ? short : full}
  </span>
);

const UsersClientTab = () => {
  const { isMobile } = useBreakpoint();
  const [loadingTable, setLoadingTable] = useState(true);
  const [data, setData] = useState([]);
  const [search, setSearch] = useState(null);

  useEffect(() => {
    refreshData();
  }, []);

  function refreshData() {
    setLoadingTable(true);
    getData();
  }

  function getData() {
    let obj = {
      search: search,
    };

    if (search == null || search == "") {
      obj = {};
    }
    getUsers(obj)
      .then((res) => {
        setLoadingTable(false);
        setData(res);
      })
      .catch((err) => {
        setLoadingTable(false);
        notificationErroInternal(
          "Aconteceu um erro inesperado, por favor, tente mais tarde."
        );
      });
  }

  const mountFilter = () => {
    return (
      <Row
        className="reviews-filter-row"
        gutter={[16, 16]}
        style={{ padding: "10px", alignItems: "center" }}
      >
        <Col xs={24} md={12} lg={10}>
          <Input
            allowClear
            value={search ?? ""}
            placeholder="Pesquisar Usuário"
            onChange={(e) => setSearch(e.target.value)}
            prefix={<Search size={18} color="#e0e0e0" />}
            style={{ width: "100%" }}
            onPressEnter={refreshData}
          />
        </Col>
        <Col xs={24} md={6} lg={4}>
          <Button
            style={{ fontFamily: FONT, width: "100%" }}
            type="primary"
            icon={
              <ArrowRight
                size={18}
                style={{ marginBottom: "-3px", marginRight: "7px" }}
              />
            }
            onClick={refreshData}
          >
            Filtrar
          </Button>
        </Col>
      </Row>
    );
  };

  const defaultActiveKey = isAdmin() ? ROLE_ADMIN : ROLE_USER_ADMIN;

  const tabItems = [
    ...(isAdmin()
      ? [
          {
            label: tabLabel(
              "Admins",
              "Administradores",
              "users-tab-label--admin",
              isMobile
            ),
            key: ROLE_ADMIN,
            children: (
              <UsersClient
                users={data.filter((item) => item.role === ROLE_ADMIN)}
                emptyMessage="Sem administradores"
                refreshData={refreshData}
              />
            ),
          },
        ]
      : []),
    {
      label: tabLabel(
        "Profs",
        "Professores",
        "users-tab-label--professor",
        isMobile
      ),
      key: ROLE_USER_ADMIN,
      children: (
        <UsersClient
          users={data.filter((item) => item.role == ROLE_USER_ADMIN)}
          emptyMessage="Sem professores"
          refreshData={refreshData}
        />
      ),
    },
    {
      label: tabLabel("Alunos", "Alunos", "users-tab-label--aluno", isMobile),
      key: ROLE_USER,
      children: (
        <UsersClient
          users={data.filter((item) => item.role == ROLE_USER)}
          emptyMessage="Sem alunos"
          refreshData={refreshData}
        />
      ),
    },
    ...(isAdmin()
      ? [
          {
            label: tabLabel(
              "Clientes",
              "Clientes",
              "users-tab-label--cliente",
              isMobile
            ),
            key: ROLE_ADMIN_CUSTOMER,
            children: (
              <UsersClient
                users={data.filter((item) => item.role == ROLE_ADMIN_CUSTOMER)}
                emptyMessage="Sem clientes"
                refreshData={refreshData}
              />
            ),
          },
        ]
      : []),
  ];

  return (
    <div className="container-users-client">
      {mountFilter()}
      <Spin spinning={loadingTable}>
        <Tabs
          className="users-tabs"
          defaultActiveKey={defaultActiveKey}
          centered={!isMobile}
          size={isMobile ? "middle" : "large"}
          style={{ fontFamily: FONT }}
          items={tabItems}
        />
      </Spin>
    </div>
  );
};
export default UsersClientTab;
